import {React, useState,useEffect} from 'react';
import { useLocation } from "react-router-dom";
import {Placeholder} from 'react-bootstrap';

import {Api} from '../component/api';
import Breadcrumb from "../component/Breadcrumb";
import ProductsList from "../component/ProductsList";
import ProductPagination from "../component/ProductPagination";

function SearchPage({ categoryId }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const searchQuery = queryParams.get("s"); // مقدار فیلد جستجو
    //const [data, setData] = useState([]);
    const [data, setData] = useState({ 
        name: "", // مقدار پیش‌فرض
        description: "", // مقدار پیش‌فرض
        meta_title: "", // مقدار پیش‌فرض
        meta_description: "", // مقدار پیش‌فرض
        meta_keywords: "", // مقدار پیش‌فرض
        active: "0", // مقدار پیش‌فرض
        images: {}, // مقدار پیش‌فرض: آبجکت خالی
        label: "", // مقدار پیش‌فرض
        products: [], // مقدار پیش‌فرض: آرایه خالی
        sort_orders: [], // مقدار پیش‌فرض: آرایه خالی
        sort_selected: false, // مقدار پیش‌فرض: بولین
        pagination: {}, // مقدار پیش‌فرض: آبجکت خالی
        facets: [], // مقدار پیش‌فرض: آرایه خالی
    });
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState([]);
    
    async function fetchData(searchQuery,nextPage=0) {

        if(!searchQuery)
        {
            return;
        }
        setLoading(true);
        try {
             const response = await Api("productSearch",{s: searchQuery,page: nextPage});
            if(response.success==true){
                setData((prevData) => ({
                    ...prevData, // نگه داشتن داده‌های فعلی
                    ...response.psdata, // به‌روزرسانی تمامی داده‌ها با پاسخ جدید
                    products: [...prevData.products, ...response.psdata.products], // ترکیب محصولات قبلی و جدید
                }));
                //setData(response.psdata);
            }
        } catch (error) {
            console.error("API Error:", error);
        } 
        finally {
            setLoading(false); // پایان بارگذاری
        }
    }
    useEffect(() => {
        fetchData(searchQuery);
    }, [searchQuery]);

  
    
    return(
        <div>
           
            <div className="container">
            {loading?
                (
                    <>
                        <nav className='breadcrumb-section' aria-label="breadcrumb-1">
                            <Placeholder className="breadcrumb" animation="glow">
                                <Placeholder xs={2} />
                            </Placeholder>
                        </nav>
                        <Placeholder as="h1" animation="glow">
                            <Placeholder xs={2} size="lg" />
                        </Placeholder>
                    </>
                ):       
                (
                    <>
                        <Breadcrumb />
                        <h1>{data.name}</h1>
                    </>
                )
            }
            <ProductsList  
                Products = {data.products} 
                loading = {loading}
            />
            <ProductPagination 
                pagination = {data.pagination}  
                fetchData = {fetchData} 
                categoryId = {searchQuery} 
                loading = {loading}
            />
            </div>
        </div>
    );
};

export default SearchPage;